import React from "react";
import "./Footer.sass";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer-container">
      <div className="footer not-mobile">
        <div className="footer-empty"></div>
        <h3>Also Available at WADI World</h3>
        <div className="footer-wadi">
          <h2>WADISHADES</h2>
          <h2>‘BAYO</h2>
        </div>
      </div>
      <div className="footer-mobile mobile">
        <div className="hteam-logo">
          <div className="hteam-logo-img">
            <Link to="/">
              <img src="/images/logo.png" alt="logo" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
